import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  position: relative;
  color: ${(props) => (props.$answered ? 'inherit' : theme.swatches.gray[100])};

  &::before {
    margin-right: ${theme.spacing.sm};
    position: absolute;
    content: '';
    top: 0;
    right: 100%;
    width: ${theme.spacing.md};
    border-radius: ${theme.spacing.sm};
    height: 100%;
    background-color: ${(props) => (props.$answered ? theme.swatches.yellow[200] : theme.semantic.surface.sunken)};
  }
`;
